// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridContainerStyle } from "@awc/App/Components/Product/ProductGridContainer";
import { color, xScreen } from "@awc/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import { css } from "styled-components";

productGridContainerStyle.container = {
    css: css`
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background-color: transparent;
        box-sizing: border-box;
        border: 1px solid ${color("common.border")};
        border-top: 6px solid ${color("secondary")};
        padding: 12px;

        ${xScreen("lte", "sm")} {
            margin: 0 auto;
        }
        ${xScreen("lte", "xs")} {
            max-width: 100%;
        }

        & > .top-section {
            margin-bottom: 12px;
            &:empty,
            &:has(> div:empty) {
                display: none;
            }
        }
        & > .middle-section {
            margin-bottom: 20px;
            &:empty {
                display: none;
            }
        }
        & > .price-section {
            margin-bottom: 10px;
            &:empty {
                display: none;
            }
        }
        & > .bottom-section {
            margin-top: auto;
            display: flex;
            flex-direction: column;
            gap: 10px;
            & > .price-section {
                display: flex;
                flex-direction: column;
                row-gap: 4px;
            }
        }

        .top-section:empty + .middle-section:empty + .bottom-section {
            margin-top: 0;
        }
    `,
};

productGridContainerStyle.image = {
    css: css`
        position: relative;
        width: 100%;
        margin: 0 auto;
        ${StyledButton} {
            width: 100%;
            height: 100%;
            img {
                max-width: 100%;
                max-height: 100%;
                height: auto;
                width: auto;
            }
        }
    `,
};

productGridContainerStyle.info = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.price = {
    css: css`
        display: flex;
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.availability = {
    css: css`
        display: flex;
        min-height: 14px;
    `,
};

productGridContainerStyle.addToCartActions = {
    css: css`
        display: flex;
        margin-top: auto;
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.addToList = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 4px;
        &:empty {
            display: none;
        }
    `,
};

productGridContainerStyle.extraContent = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};
